import React from 'react'
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
import InsertLinkRoundedIcon from '@material-ui/icons/InsertLinkRounded';

const useStyles = makeStyles((theme) => ({
    contentComponent:{  
       display: 'flex', 
       width:"100%",
       backgroundColor: theme.palette.background.grey,
       marginTop: theme.spacing(1.5), 
       marginBottom: theme.spacing(1.5),   
       
       padding: theme.spacing(1),
       borderRadius: "0.5rem",
    },

    icon:{
        marginRight: theme.spacing(1.5), 
     },

     text: {
         margin:0,
         padding:0,
         textAlign: 'left'
     }
}));

 
export default function InfoBox(props) {
    const classes = useStyles();
    const {message, icon} = props; 
   
    const parseIcon=(icon)=>{
        let iconView; 
        if(icon=="info"){
            iconView = <InfoOutlinedIcon className={classes.icon} color='info'/>;   
        }else  if(icon=="error"){
            iconView =  <ErrorIcon className={classes.icon} color='error'/>;     
        }else  if(icon=="link"){
            iconView = <ReceiptOutlinedIcon className={classes.icon} color='info'/>;   
        }
        return iconView
    }

    return (
        <div className={classes.contentComponent}>
        {icon && 
            parseIcon(icon)
        }
        <Typography variant ='body1' className={classes.text}>{message}</Typography>
        </div>
    )

}
